import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoNb: CultureInfo = {
  name: 'nb',
  displayName: 'Norwegian Bokmål',
  iso3LanguageCode: 'nob',
  iso2LanguageCode: 'nb',
  ietfLanguageTag: 'nb',
  parent: null
};
